import { useMemo } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useSplitTestIdByVariantIdSelector = (variantId: string) => {
  const state = useGetEditOrActual();

  return useMemo(() => {
    const test = Object.keys(state.splitTests);
    return test?.find(k => state.splitTests[k]?.variants?.find(s => s.messageId === variantId));
  }, [state.splitTests, variantId]);
};
